// i18next-extract-mark-ns-start LandingAds
import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';

import { Container, Content } from '../components/home/v2/styledComponents';
import MenuBar from '../components/home/MenuBar';
import FootNote from '../components/LandingPage/FootNote';
import FooterSEOLinks from '../components/LandingPage/FooterSEOLinks';
import Footer from '../components/home/v3/Footer';
import Layout from '../layouts/index';
import {
  getFootNoteTitle, getBreadCrumb, getPosition,
} from './LandingLocalityLeatherGoodsFormatter';
import TaglineCard from '../components/home/TaglineCard1';
import OurPartners from '../components/home/v4/OurPartners';
import HeaderLP from '../components/LandingPage/HeaderLP';
import WorksBanner from '../components/WorksBanner';
import HowItWorksBlockLandingPage from '../components/home/HowItWorks/HowItWorksBlockLandingPage';
import TipsServices from '../components/home/OurServices/TipsServices';
import Feedbacks from '../components/home/v5/Feedbacks';
import FAQBlock from '../components/FAQBlock';
import { getLeatherGoodsArticles } from '../components/home/OurServices/LeatherGoodsServices';
import { mostFrequentQuestions } from '../components/home/faqQuestions';
import { getLeatherGoodsHeaderSteps, getLeatherGoodsServices } from '../pagesComponents/home/LandingMainLeatherGoods';
// assets
import bannerLeatherGoods from '../assets/bannerLeathergoods.jpg';

interface LandingLocalityLeatherGoodsJsonProps {
  data: {
    landingsLocalitiesLeatherGoodsJson: {
      slug: string;
      city: string;
      locality: string;
      arrondissement: string;
      paragraph: string;
      links: string[];
    };
  };
}

export default function LandingLocalityLeatherGoodsPageTemplate({ data: { landingsLocalitiesLeatherGoodsJson } }: LandingLocalityLeatherGoodsJsonProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.scrollTo(0, 0);
    window.onbeforeunload = null;
  }, []);

  const {
    slug, city, locality, arrondissement, paragraph, links,
  } = landingsLocalitiesLeatherGoodsJson;
  const position = getPosition({ locality, city, arrondissement });
  const tagline = t('Confiez vos sacs abîmés à nos experts maroquiniers');
  const title = t('Votre service de maroquinerie,\n livré chez vous à {{position}}', { position });

  return (
    <Layout routeSlug={slug}>
      <Container>
        <Content full hasNoBanner>
          <MenuBar />
          <HeaderLP
            image={bannerLeatherGoods}
            title={title}
            subtitle={t('Confiez vos sacs et accessoires à l’expertise de nos artisans maroquiniers ')}
            preFilledSteps={{ selectedCategory: 'accessories' }}
            steps={getLeatherGoodsHeaderSteps(t)}
            isPackage
          />
          <WorksBanner works={getLeatherGoodsServices(t)} marginTop />
          <TaglineCard tagline={tagline} />
          <HowItWorksBlockLandingPage landingPageType="package" />
          <TipsServices articles={getLeatherGoodsArticles(t)} noTitle />
          <Feedbacks marginTop position={position} />
          <FAQBlock questions={mostFrequentQuestions(t)} />
          <OurPartners isLandingPage />
          <FootNote
            title={getFootNoteTitle({
              t, locality, city, arrondissement,
            })}
            paragraph={paragraph}
            links={links}
            itemListElement={getBreadCrumb({
              t, locality, city, arrondissement,
            })}
            isLeatherGoods
          />
          <FooterSEOLinks city={city} locality={locality} arrondissement={arrondissement} isLeatherGoods />
          <Footer isLeatherGoods />
        </Content>
      </Container>
    </Layout>
  );
}

export const landingLocalityLeatherGoodsPageQuery = graphql`
  query landingsLocalitiesLeatherGoodsQuery($slug: String!, $language: String!) {
    landingsLocalitiesLeatherGoodsJson(slug: { eq: $slug }) {
      slug
      city
      locality
      zipcode
      arrondissement
      paragraph
      links
    }
    locales: allLocale(
      filter: { language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
